if (
  import.meta.env.VITE_ENV === 'stage' ||
  import.meta.env.VITE_ENV === 'upgrade' ||
  import.meta.env.VITE_ENV === 'production'
) {
  window.DD_RUM.onReady(function() {
    window.DD_RUM.init({
      clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
      applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
      service: 'tapgoods_front_end',
      version: import.meta.env.VITE_APP_VERSION || 'unknown',
      env: import.meta.env.VITE_ENV,
      site: 'datadoghq.com',
      sampleRate: 100,
      premiumSampleRate: 100, // if not included - default 100
      trackInteractions: true,
      beforeSend: (event, context) => {
        // discard a RUM error if its message includes 'ResizeObserver loop'
        if (event.type === 'error' && event.error.message.includes('ResizeObserver loop')) {
          return false
        }
      },
      allowedTracingOrigins: [
        'https://api.tapgoods.com',
        /https:\/\/.*\.tapgoods\.dev/,
      ],
    });
  });
}
